import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowRight, Star } from 'lucide-react';
import { Hero } from '../components/Hero';
import { FeaturedServices } from '../components/FeaturedServices';
import { SpecialsStrip } from '../components/SpecialsStrip';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { SectionHeading } from '../components/SectionHeading';
import { Gallery } from '../components/Gallery';
import { Reviews } from '../components/Reviews';
import { ServiceAreas } from '../components/ServiceAreas';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';

/** Old one-page anchors now live on their own pages. */
const legacyAnchors: Record<string, string> = {
  services: '/services',
  packages: '/services',
  extras: '/services',
  'service-details': '/services',
  about: '/about',
  gallery: '/gallery',
  reviews: '/reviews',
  faq: '/faq',
  contact: '/contact',
  'contact-form': '/contact'
};
export function HomePage() {
  const {
    hash
  } = useLocation();
  const navigate = useNavigate();
  usePageMeta({
    title: "Mike's Pro Detail | Mobile Car Detailing in Ventura County",
    description: "Mike's Pro Detail brings mobile car detailing to your home or office in Ventura County. Interior, exterior and full details. Call or text 818-381-9905.",
    path: '/'
  });
  useEffect(() => {
    const target = legacyAnchors[hash.slice(1)];
    if (target) navigate(target, {
      replace: true
    });
  }, [hash, navigate]);
  return <main data-id="element-943" data-mp="20qp4qmt7efuk">
      <Hero data-id="element-944" data-mp="20qyy8kdgj550" />
      <SpecialsStrip data-id="element-945" data-mp="20qfnbnm85h0h" />
      <FeaturedServices data-id="element-946" data-mp="20pxgjx1xrkeb" />
      <WhyChooseUs data-id="element-947" data-mp="20ss622zt3vel" />

      <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" data-id="element-948" data-mp="25ps7g0lpo9zd">
        <div className="max-w-6xl mx-auto" data-id="element-949" data-mp="25nfiv4lg71dc">
          <SectionHeading title="Our Work" subtitle="Real before-and-after results from customers in Ventura County." data-id="element-950" data-mp="3c6ni32vezo1l" />
          <Gallery limit={4} data-id="element-951" data-mp="3h3nndbkfwmrn" />
          <div className="mt-10 text-center" data-id="element-952" data-mp="3h71pcip6ytyk">
            <Link to="/gallery" className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/80 text-white hover:bg-white hover:text-black font-black uppercase tracking-wider rounded-sm transition-colors duration-150" data-id="element-953" data-mp="2rg0em4mlb301">
              View Gallery
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-954" data-mp="31cmvkibsp9ws" />
            </Link>
          </div>
        </div>
      </section>

      <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" data-id="element-955" data-mp="28psdfs2gammh">
        <div className="max-w-7xl mx-auto" data-id="element-956" data-mp="23rh6pq7gcs8h">
          <SectionHeading title="5-Star Mobile Detailing Reviews" subtitle={<span className="inline-flex items-center gap-2" data-id="element-958" data-mp="2ign4d9qn6ae9">
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" aria-hidden="true" data-id="element-959" data-mp="2ii7vepdqzb7d" />
                5.0 average rating across Google &amp; Yelp
              </span>} data-id="element-957" data-mp="23sju3o5kgcjn" />
          <Reviews limit={3} data-id="element-960" data-mp="1py9ga1v3y2sd" />
          <div className="mt-10 text-center" data-id="element-961" data-mp="1pxhiqlhy9uzg">
            <Link to="/reviews" className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/80 text-white hover:bg-white hover:text-black font-black uppercase tracking-wider rounded-sm transition-colors duration-150" data-id="element-962" data-mp="1kzoevz44dd2c">
              Read More Reviews
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-963" data-mp="3mq6q6ix3akn5" />
            </Link>
          </div>
        </div>
      </section>

      <ServiceAreas data-id="element-964" data-mp="3rq1h2mgv7a87" />
      <CallCta data-id="element-965" data-mp="3rpjaox0hnfmk" />
    </main>;
}